<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->

      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{ form.id ? "Editar Dato Familiar" : "Crear Dato Familiar" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs7>
                <v-text-field
                  name="label"
                  label="Nombre Completo"
                  v-model="form.nombre_completo"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-select
                  :items="parentescos"
                  :item-value="val => parseInt(val.id)"
                  item-text="valor"
                  label="Parentesco"
                  v-model="form.id_parametro_parentesco"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs7>
                <v-text-field
                  name="label"
                  label="Nacionalidad"
                  v-model="form.nacionalidad"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  type="date"
                  name="label"
                  label="Fecha de Nacimiento"
                  v-model="form.fecha_nacimiento"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="sexos"
                  :item-value="val => parseInt(val.id)"
                  item-text="valor"
                  label="Sexo"
                  v-model="form.id_parametro_sexo"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      parentescos: [],
      sexos: []
    };
  },
  mounted() {
    //Llamando al metodo cargar Parentescos
    this.cargarParentescos();
    this.cargarSexos();

    //
    this.$bus.$on("openDialogCrearActualizarDatoFamiliar", item => {
      this.form = item;
      this.dialog = true;
    });
  },

  //Métodos

  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },

    //Método cargar sexos

    async cargarSexos() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
						 query{
              params(tipo:"SEXO"){
                rows{
                  id
                  valor
                }
              }
              }
					`
        });

        this.sexos = respuesta.params.rows;
      } catch (error) {
        console.log(error);
      }
    },

    //cargar parentescos

    async cargarParentescos() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
						 query{
              params(tipo:"parentesco"){
                rows{
                  id
                  valor
                }
              }
              }
					`
        });

        this.parentescos = respuesta.params.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        try {
          this.form.id_parametro_parentesco = parseInt(
            this.form.id_parametro_parentesco
          );
          //  this.form.id_parametro_sexo = parseInt(this.form.id_parametro_sexo)
          if (this.form.id) {
            //Editando registro
            const id = this.form.id;
            delete this.form.id;
            delete this.form._user_created;
            delete this.form._user_updated;
            delete this.form._created_at;
            delete this.form._updated_at;
            delete this.form.parametro_parentesco;

            await this.$service.graphql({
              query: `
								mutation edit($id: ID!, $dato_familiar: EditDatoFamiliar!){
									datoFamiliarEdit(id: $id, dato_familiar: $dato_familiar){
										id
                    
									}
								}
							`,

              variables: {
                id: id,
                dato_familiar: this.form
              }
            });
          } else {
            //Creando nuevo registro
            this.form.id_estado = 1;
            let user = this.$storage.get("user");
            if (this.$route.params.id) {
              this.form.id_persona = parseInt(this.$route.params.id)
            } else {
              this.form.id_persona = user.id_persona
            }
            await this.$service.graphql({
              query: `
								mutation add($dato_familiar: NewDatoFamiliar!){
									datoFamiliarAdd(dato_familiar: $dato_familiar){
										id
                    
									}
								}
							`,
              variables: {
                dato_familiar: this.form
              }
            });
          }
        } catch (error) {
          console.log(error);
        }
        this.$message.success();
        this.loading = false;
        this.close();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/dialogs/CrearActualizarDatoFamiliar.vue